import { flowRight } from 'lodash';
import { connect } from 'react-redux';

import { getPostPageEnabled } from '../selectors/app-data-selectors';
import { isDashboard } from '../selectors/view-mode-selectors';
import { isBusinessManager as getIsBusinessManager } from '../../business-manager-old/selectors/is-business-manager-selectors';
import { isPostPageBundle } from '../services/section-route-utils';
import withHocName from './with-hoc-name';

const getFontClassName = property => `blog-post-${property}-font`;
const getFontClassNameWithStyle = property => `blog-post-${property}-style-font`;

const mapStateToProps = state => {
  const isBusinessManager = isDashboard(state) || getIsBusinessManager(state);
  const usePageFont = isPostPageBundle() || (isBusinessManager && getPostPageEnabled(state));
  return {
    titleFontClassName: getFontClassName('title'),
    contentFontClassName: getFontClassName(usePageFont ? 'page' : 'description'),
    contentFontClassNameWithStyle: getFontClassNameWithStyle('description'),
  };
};

// prettier-ignore
export default flowRight(
  connect(mapStateToProps),
  withHocName('WithFontClassName')
);
